export const locale = {
    lang: 'en',
    data: {
        'Headers': {
            'QuestionList': 'Questions:'
        },
        'QuestionTypeCategory': {
            'value1': 'Textbox',
            'value2': 'Multi Choice',
            'value3': 'Single Choice',
            'value4': 'Rating'
        },
        'BUTTONS': {
            'NEWPROJECTOFFER': 'New Project Offer',
            'AddQuestion': 'Add Question',
            'SendReminder': 'Send Reminder',
            'Save': 'Save',
            'Cancel': 'Cancel',
            'Text': 'Text',
            'Add':'Add',
            'HideAnswer': 'Hide Answer'
        },
        'FIELDS': {
            'Question': 'Question',
            'SrNo': 'Sr No.',
            'Type': 'Type',
            'Answer': 'Answer',
            'WithTextbox': 'With Textbox',
            'ReminderMsg': 'Reminder Message',
            'DragAndDropFile':'Drag and drop file here',
            'Or':'Or',
            'BrowseForFile':'Browse for file',
            'EmailTemplate':'Email Template'
        },
        'VALIDATIONS': {
            'QuestionRequired': 'Question required',
            'CoWorkerRequired': 'CoWorker Required',
            'Not-Found-Worker': 'Co-worker not found',
            'ReminderMsgRequired': 'Reminder Message required',
        },
        'PlaceHolder': {
            'SelectCoWorker': 'Select Co-Worker',
            'Search-worker': 'Search Co-worker',
        },
        'MESSAGES': {
            'NoQuestionAnswerFound': 'No Question Found.',
            'AddTypeList': 'Add at least one value to the type list.',
            'AddTypeListItem': 'Add value to the type list.',
            'Saved': 'Saved successfully.',
        },
        'TOOTIPORTITLE':{
            'ViewOrEdit':'View Or Edit',
            'Delete':'Delete',
        },
        'ToolTip': {
            'SendReminderBySMS': 'Send reminder by Sms',
            'SendReminderByEmail': 'Send reminder by email',
            'SendReminderByNotification': 'Send reminder by notification',
        }
    }
}